import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateTime(date) {
  // Convert to IST first, then format
  const dateInIST = new Date(new Date(date).toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  return format(dateInIST, 'yyyy/MM/dd HH:mm:ss');
}


export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}
